// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"clipPath":"url(#clip0_101749_96975)"},"nodeName":"g","children":[{"attributes":{"fill":"currentColor","d":"M3.5 7C3.5 4.23858 5.73858 2 8.5 2C11.2614 2 13.5 4.23858 13.5 7C13.5 9.76142 11.2614 12 8.5 12C5.73858 12 3.5 9.76142 3.5 7Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M5 14C2.23858 14 0 16.2386 0 19V21H17V19C17 16.2386 14.7614 14 12 14H5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M24.0005 21H19.0005V19C19.0005 17.0413 18.196 15.2705 16.8995 14H19.0005C21.7619 14 24.0005 16.2386 24.0005 19V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.5005 12C14.871 12 14.2687 11.8837 13.7139 11.6713C14.8248 10.4324 15.5005 8.79509 15.5005 7C15.5005 5.20491 14.8248 3.56764 13.7139 2.32865C14.2687 2.11632 14.871 2 15.5005 2C18.2619 2 20.5005 4.23858 20.5005 7C20.5005 9.76142 18.2619 12 15.5005 12Z"},"nodeName":"path","children":[]}]}]};

@tag('t-icon-member-filled')
export default class MemberFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'member-filled',
    }
  }
}
